// This file contains the functionality used in the product lists

import { helpers } from './helpers';

export const list = {
    init: () => {
        console.debug("product-list.js: init");
        if ($("#js-product-list").length) {
            helpers.removePriceDecimals(".price, .price span, .regular-price, .discount, .discount-tag");
            $('body').on('change', '.select-product-order', list.sortProductList);
            $('body').on('click', '.toggle-list-view-btn', list.toggleProductListView);
            $('body').on('mouseenter', '.product-thumbnail', list.toggleHoverImage).on('mouseleave', '.product-thumbnail', (e) => {
                $(e.currentTarget).find(".front-image").removeClass('hidden-img');
            });
            list.pushToDataLayer();
        } else if ($(".product-slider").length) {
            $('.product-thumbnail').hover(list.toggleHoverImage, (e) => {
                $(e.currentTarget).find(".front-image").removeClass('hidden-img');
            });
        }
    },
    pushToDataLayer: () => {
        // data layer push needs to happen when the products actually load (load more products etc) and are viewed
        let data = {
            event: "view_item_list",
            ecommerce: {
                items: []
            }
        };
        $(".product-list-item").each((i, el) => {
            let prod = $(el);
            var item = {
                item_id: prod.find("meta[itemprop='sku']").attr("content"),
                item_name: prod.find(".product-list-item-content > h1 > a").text().trim(),
                index: i + 1,
                item_brand: prod.find(".manufacturer").text(),
                //item_variant: "green",
                //discount: 2.22,
            }
            let countrySuffix = prestashop.urls.base_url == 'https://www.dpj.se/' ? 'SE' : prestashop.urls.base_url.slice(-3).replace("/", "").toUpperCase();
            item.item_id = 'DPJ' + countrySuffix + prod.find("meta[itemprop='sku']").attr("content");
            //item.price = prod.find(".product-price-and-shipping.hr-no-vat"),
            $(".breadcrumb-item").each((i, el) => {
                if ($("body").hasClass("product-id-category-464") && i > 0) {
                    var catIndex = i == 1 ? "" : i;
                    item["item_category" + catIndex] = $(el).find("span[itemprop='name'").text();
                }
                else if (!$("body").hasClass("product-id-category-464") && i > 1) {
                    var catIndex = i == 2 ? "" : i - 1;
                    item["item_category" + catIndex] = $(el).find("span[itemprop='name'").text();
                }
            });
            data.ecommerce.items.push(item);
        });
        // console.log(data);
        dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        dataLayer.push(data);
    },
    sortProductList: (e) => {
        const url = `${$(e.target).val()}#js-product-list-top`;
        if (helpers.isURL(url)) {
            window.location.href = url;
        }
    },
    toggleProductListView: (e) => {
        const btn = $(e.currentTarget);
        const list = $("#js-product-list");
        if (btn.hasClass("grid")) {
            list.addClass("grid");
            list.removeClass("list");
        }
        else if (btn.hasClass("list")) {
            list.addClass("list");
            list.removeClass("grid");
        }
        $('.toggle-list-view-btn').removeClass("selected");
        btn.addClass("selected");
    },
    toggleHoverImage: (e) => {
        const box = $(e.currentTarget);
        const imgData = box.find(".back-image-data");
        const backImg = box.find(".back-image");
        const frontImg = box.find(".front-image");
        if (imgData.length && !backImg.length) {
            const img = `<img class="back-image" src="${imgData.attr("data-src")}" alt="${imgData.attr("data-alt")}" data-full-size-image-url="${imgData.attr("data-full-size-image-url")}">`;
            box.append(img);
            imgData.remove();
            frontImg.addClass("hidden-img");
        }
        else if (!imgData.length && backImg.length) {
            frontImg.addClass("hidden-img");

        }
    }
}
